<template>
    <transition name="fade">
        <div class="patient-coaching-summary-logs">
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        v-if="metrics[0]"
                        :metrics="participant.metrics"
                        :metric="metrics[0]"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_' + metrics[0]) }}</label>
                </b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        v-if="metrics[1]"
                        :metrics="participant.metrics"
                        :metric="metrics[1]"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_' + metrics[1]) }}</label>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        v-if="metrics[2]"
                        :metrics="participant.metrics"
                        :metric="metrics[2]"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_' + metrics[2]) }}</label>
                </b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        v-if="metrics[3]"
                        :metrics="participant.metrics"
                        :metric="metrics[3]"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_' + metrics[3]) }}</label>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>

        </div>
    </transition>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'PatientCoachingSummaryLogs',
    computed: {
        participant () {
            return this.$store.state.patientParticipant
        },
        metrics() {
            const metrics = (this.participant.metrics ? this.participant.metrics : []).map((metric) => metric.metric);
            return [... new Set(metrics)]
        }
    }
})
</script>
